import { useAppLogo } from "helpers/useAppSetting";
import React from 'react';
import PropTypes from 'prop-types';
import { VALUE_CLS, CHECK_DISPLAY_CLS } from "../pifStyles";

const DetailBDSGeneralInformation = ({ project, building, adaptation, area }) => {
  const logo = useAppLogo();

  return (
    <div className="tw-flex tw-gap-x-3 tw-text-sm">
      <div>
        <img
          src={logo}
          alt="Logo Pebsteel"
          width="160"
          height="60"
          className="tw-object-contain tw-rounded-sm"
          style={{ maxWidth: '100%' }}
        />
      </div>
      <div className="tw-w-3/12">
        <div className="tw-flex tw-gap-x-2 tw-mb-2">
          <div>Quote No:</div>
          <div className="tw-flex-1"><span className={VALUE_CLS}>{project.q_number}</span></div>
        </div>
        <div className="tw-flex tw-gap-x-2 tw-mb-2">
          <div>P/Job No:</div>
          <div className="tw-flex-1"><span className={VALUE_CLS}>{building.j_number}</span></div>
        </div>
      </div>
      <div className="tw-w-2/12">
        <div className="tw-flex tw-gap-x-2 tw-mb-2">
          <div>CO#:</div>
          <div className="tw-flex-1"><span className={VALUE_CLS}>{adaptation?.co || '00'}</span></div>
        </div>
        <div className="tw-flex tw-gap-x-2 tw-mb-2">
          <div>REV#:</div>
          <div className="tw-flex-1"><span className={VALUE_CLS}>{adaptation?.rev}</span></div>
        </div>
      </div>
      <div className="tw-w-2/12">
        <div className="tw-flex tw-gap-x-2 tw-mb-2">
          <div>Date:</div>
          <div className="tw-flex-1"><span className={VALUE_CLS}>{adaptation?.entry_date}</span></div>
        </div>
        <div className="tw-flex tw-gap-x-2 tw-mb-2">
          <div>Date:</div>
          <div className="tw-flex-1"><span className={VALUE_CLS}>{adaptation?.entry_date}</span></div>
        </div>
      </div>
      <div className="tw-w-3/12">
        <div className="tw-flex tw-gap-x-2">
          <div>
            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                name="for_order_entry"
                readOnly
              />
              <span>For Order Entry</span>
            </label>
          </div>
          <div className="tw-flex-1">
            <label className="tw-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                className={CHECK_DISPLAY_CLS}
                name="for_quotation"
                checked={true}
                readOnly
              />
              <span>For Quotation</span>
            </label>
          </div>
        </div>
        <div className="tw-flex tw-gap-x-2">
          <div>
            <div>Bldg No : <span className={VALUE_CLS}>{building.name}</span></div>
          </div>
          <div className="tw-flex-1">
            <div>Area No: <span className={VALUE_CLS}>{area.id}</span></div>
          </div>
        </div>
      </div>
    </div>
  )
};

DetailBDSGeneralInformation.propTypes = {
  project: PropTypes.object.isRequired,
  building: PropTypes.object.isRequired,
  adaptation: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired
}

export default DetailBDSGeneralInformation;
